// extracted by mini-css-extract-plugin
var _1 = "SettingsSectionUpsell-module__animatedBackground--FfFRZ";
var _2 = "SettingsSectionUpsell-module__cards--XY3uq";
var _3 = "SettingsSectionUpsell-module__cardsWrapper--qMMT9";
var _4 = "SettingsSectionUpsell-module__contentWrapper--v7NwO";
var _5 = "SettingsSectionUpsell-module__description--PJ3gC";
var _6 = "SettingsSectionUpsell-module__header--Yzmn4";
var _7 = "SettingsSectionUpsell-module__headerUpgradeButton--PJoKx";
export { _1 as "animatedBackground", _2 as "cards", _3 as "cardsWrapper", _4 as "contentWrapper", _5 as "description", _6 as "header", _7 as "headerUpgradeButton" }
